import { supabase } from "./supabase"
import type { RealtimeChannel } from "@supabase/supabase-js"
import type { Notification } from "@/types/notification"

/**
 * Subscreve a mudanças em tempo real na tabela notifications.
 * Requer: Realtime habilitado na tabela + RLS configurado.
 */
export function subscribeToNotifications(
  onNotification: (n: Notification) => void,
  onInvalidate?: () => void // chamar quando refetch do contador for necessário
): RealtimeChannel | null {
  if (!supabase) return null

  const channel = supabase
    .channel("notifications")
    .on(
      "postgres_changes",
      {
        event: "INSERT",
        schema: "public",
        table: "notifications",
      },
      (payload) => {
        const raw = payload.new as Record<string, unknown>
        // Colunas no Postgres (Prisma): userId, createdAt, relatedId (camelCase)
        const n: Notification = {
          id: raw.id as string,
          userId: (raw.userId ?? raw.user_id) as string,
          title: raw.title as string,
          message: raw.message as string,
          type: raw.type as Notification["type"],
          read: raw.read as boolean,
          relatedId: (raw.relatedId ?? raw.related_id) as string | undefined,
          createdAt: (raw.createdAt ?? raw.created_at) as string,
          updatedAt: (raw.updatedAt ?? raw.updated_at) as string,
        }
        onNotification(n)
        if (!n.read && onInvalidate) onInvalidate()
      }
    )
    .on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "notifications",
      },
      () => {
        if (onInvalidate) onInvalidate()
      }
    )
    .subscribe()

  return channel
}

export function unsubscribeNotifications(channel: RealtimeChannel | null) {
  if (channel && supabase) {
    supabase.removeChannel(channel)
  }
}
